export default __webpack_public_path__ + "static/char-42-c30c42631616a4b4821dbb667d0a61a2.gif";